var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteLineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete_-_Line_icon",
    "data-name": "Delete - Line icon",
    transform: "translate(-4858 -2171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4366",
    "data-name": "Rectangle 4366",
    width: 20,
    height: 20,
    transform: "translate(4858 2171)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-1053853",
    transform: "translate(4723.718 2115.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34156",
    "data-name": "Path 34156",
    d: "M152.59,110.087H135.974a.354.354,0,0,1,0-.707H152.59a.354.354,0,0,1,0,.707Z",
    transform: "translate(0 -50.379)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34157",
    "data-name": "Path 34157",
    d: "M280.933,59.708h-4.95a.354.354,0,0,1-.354-.354A2.475,2.475,0,0,1,278.1,56.88h.707a2.475,2.475,0,0,1,2.475,2.475.354.354,0,0,1-.354.354ZM276.372,59h4.172a1.775,1.775,0,0,0-1.732-1.414H278.1A1.775,1.775,0,0,0,276.372,59Z",
    transform: "translate(-134.353)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34158",
    "data-name": "Path 34158",
    d: "M337.224,189.986a.354.354,0,0,1-.354-.354v-9.9a.354.354,0,1,1,.707,0v9.9a.353.353,0,0,1-.354.354Z",
    transform: "translate(-193.119 -117.55)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34159",
    "data-name": "Path 34159",
    d: "M407.878,190.146a.354.354,0,0,1-.325-.375l.707-9.9a.361.361,0,0,1,.375-.325.353.353,0,0,1,.325.375l-.707,9.9A.353.353,0,0,1,407.878,190.146Z",
    transform: "translate(-260.944 -117.71)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34160",
    "data-name": "Path 34160",
    d: "M250.414,190.146a.354.354,0,0,1-.354-.325l-.707-9.9a.354.354,0,0,1,.325-.375.361.361,0,0,1,.375.325l.707,9.9a.353.353,0,0,1-.325.375Z",
    transform: "translate(-109.137 -117.71)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34161",
    "data-name": "Path 34161",
    d: "M179.58,158.982h-4.95a3.189,3.189,0,0,1-3.154-2.779l-1.45-11.313a.353.353,0,0,1,.3-.4.361.361,0,0,1,.4.3l1.45,11.313a2.482,2.482,0,0,0,2.454,2.157h4.95a2.482,2.482,0,0,0,2.454-2.15l1.45-11.313a.361.361,0,0,1,.4-.3.353.353,0,0,1,.3.4l-1.45,11.313a3.189,3.189,0,0,1-3.154,2.772Z",
    transform: "translate(-33.014 -84.072)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLineicon);
export default __webpack_public_path__ + "static/media/Delete - Line icon.8a844a0a54dd3346ed442781c9211f05.svg";
export { ForwardRef as ReactComponent };